import React from 'react';

export function EventCard({ event, isAdmin, onRegister, onEdit, onDelete }) {
  const isPast = new Date(event.date) < new Date();

  return (
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        {event.image_url && (
          <div className="mb-3" style={{ height: '150px', overflow: 'hidden', borderRadius: '4px' }}>
            <img src={event.image_url} alt={event.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        )}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h5 className="card-title m-0">{event.name}</h5>
          <span className="badge bg-primary">Event #{event.id}</span>
        </div>
        <p className="card-text text-muted">{event.description}</p>
        <div className="mb-3">
          <p className="mb-1">
            <strong>📅 Date:</strong> {new Date(event.date).toLocaleDateString()}
          </p>
          <p className="mb-1">
            <i className="bi bi-clock me-2"></i> {event.time}
          </p>
          <p className="text-muted small mb-3">
            <i className="bi bi-geo-alt me-2"></i> {event.location}
          </p>
          {event.price > 0 && (
            <p className="text-success fw-bold mb-3">
              <i className="bi bi-tag-fill me-2"></i> ${event.price.toFixed(2)}
            </p>
          )}

          <div className="d-flex justify-content-between align-items-center mt-auto pt-3 border-top">
            <strong>👥 Capacity:</strong> {event.registrations}/{event.capacity}
          </div>
        </div>
        <span className={`badge ${isPast ? 'bg-secondary' : 'bg-success'}`}>
          {isPast ? 'Past Event' : 'Upcoming'}
        </span>
      </div>
      <div className="card-footer bg-white">
        {isAdmin ? (
          <div className="btn-group w-100" role="group">
            <button
              className="btn btn-sm btn-warning"
              onClick={() => onEdit(event)}
            >
              Edit
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => onDelete(event.id)}
            >
              Delete
            </button>
          </div>
        ) : (
          <>
            {!event.allow_registrations ? (
              <button className="btn btn-secondary w-100" disabled>
                Registrations Closed
              </button>
            ) : isPast ? (
              <button className="btn btn-secondary w-100" disabled>
                Event Ended
              </button>
            ) : event.registrations < event.capacity ? (
              <button
                className="btn btn-primary w-100"
                onClick={() => onRegister(event)}
              >
                Register Now
              </button>
            ) : (
              <button className="btn btn-danger w-100" disabled>
                Capacity Full
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
